<template>
  <!-- 抽奖 -->
  <answer-reward v-if="isLottery && hasReward" />
  <!-- 正常红包 -->
  <answer-award v-else-if="!isQuality && hasReward" />
</template>

<script>
import AnswerReward from './AnswerReward.vue'
import AnswerAward from '../end/AnswerAward.vue'
import { AnswerStatus } from 'dygc'

export default {
  name: 'AwardAnswerWrapper',
  components: { AnswerReward, AnswerAward },
  data() {
    return {}
  },
  computed: {
    currentAwardData(){
      return this.$bus.currentAwardData || {}
    },
    isLottery() {
      return this.currentAwardData.awardIsLottery && this.currentAwardData.bindAward?.lotteryCategory !== 4
    },
    currentUserHasReward() {
      const data = this.currentAwardData
      return !data.awardYuanAmount && !data.bindAward
    },
    hasReward() {
      const data = this.currentAwardData
      return data.hasReward || ((this.$bus.lottery.lotteryAwards || []).length && !this.$bus.lottery.lotteryExpired)
    },
    isQuality() {
      return this.$bus.overData.status === AnswerStatus.QUALITY
    }
  }
}
</script>

<style scoped>

</style>
